import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../helpers';

@Component({
  selector: '.page-wrapper',
  templateUrl: './layout.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class LayoutComponent implements AfterViewInit {

  sideMenuCollapsed = false

  constructor() {
    try {
      this.sideMenuCollapsed = localStorage.getItem('sideMenuCollapsed') === 'true' ? true : false
    } catch {
      // No LocalStorage access
    }
  }

  ngAfterViewInit () {
    Helpers.initLayout();
  }

  toggleSideMenu () {
    this.sideMenuCollapsed = !this.sideMenuCollapsed
    try {
      localStorage.setItem('sideMenuCollapsed', `${this.sideMenuCollapsed}`)
    } catch {
      // No LocalStorage access
    }
  }

  getToggleSideMenu () {
    return this.toggleSideMenu.bind(this)
  }
}
